import { render, staticRenderFns } from "./pin-list.vue?vue&type=template&id=1a4d1cb6&"
import script from "./pin-list.vue?vue&type=script&lang=js&"
export * from "./pin-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports